import BusyType from 'owa-service/lib/contract/BusyType';
import EnhancedLocation from 'owa-service/lib/contract/EnhancedLocation';
import { format, isStringNullOrWhiteSpace } from 'owa-strings';
import { getOwaMiniCommonStrings } from 'owa-strings/owa-mini-common-strings';

const EMPTY_STRING = '';

/**
 * Returns the Aria label for an event for its time and duration
 * @param event
 */
const getCalendarItemAriaLabelWithoutOnGoingStatus = (
    subject: string,
    location: EnhancedLocation,
    timeDurationLabel: string,
    isAllDayEvent: boolean,
    isUpcomingOrOngoing: boolean,
    freeBusyType: BusyType
) => {
    const strings = getOwaMiniCommonStrings();
    const locationAriaLabel: string =
        !isAllDayEvent && location && !isStringNullOrWhiteSpace(location.DisplayName)
            ? format(strings.singleLocationAriaLabel, location.DisplayName)
            : EMPTY_STRING;

    const activeAriaLabel: string = isUpcomingOrOngoing
        ? format(strings.activeEventAriaLabel, EMPTY_STRING)
        : EMPTY_STRING;

    return format(
        strings.calendarSurfaceItemAriaLabel,
        subject,
        locationAriaLabel,
        timeDurationLabel,
        freeBusyType,
        activeAriaLabel
    );
};

export default getCalendarItemAriaLabelWithoutOnGoingStatus;
